module.exports = __webpack_public_path__ + "static/boston-aea949c0028926b4c8ca62f8cbee94d3.png";